<template>
  <div>
    <wrapper-edit
            :wrapper-width="wrapperWidth"
            @back="paasPageBack('', serviceUrl+'/list?sysEnumGroupCode='+paasFormData.sysEnumGroupCode)"  class="enum-table">
      <Form ref="paasForm" slot="form"
            :model="paasFormData"
            :rules="paasFormRules"
            :label-width="defaultLabelWidth" style="margin-bottom:10px;">
        <Row>
          <FormItem label="枚举编码:"  prop="sysEnumCode" class="ivu-col-span-12" >
            <Input v-model="paasFormData.sysEnumCode"
                   clearable ></Input>
          </FormItem>
          <FormItem label="枚举名字:" prop="name" class="ivu-col-span-12" >
            <Input v-model="paasFormData.name"
                   clearable ></Input>
          </FormItem>
        </Row>
        <div class="edit-oper-toolbar">
          <Button type="primary" @click="paasFormSubmit('paasForm')">提交</Button>
          <Button @click="paasPageBack('', serviceUrl+'/list?sysEnumGroupCode='+paasFormData.sysEnumGroupCode)" style="margin-left: 8px">返回</Button>
        </div>
        <Modal v-model="nodeIconModal" class="paas-select-page" width="80" title="图标选择" :styles="{top: '10px'}">
          <IconSelect @save="saveIcon" type="icon"/>
          <div slot="footer">
          </div>
        </Modal>
      </Form>
      <Table :data="paasFormData.datas" :columns="tableColumns" stripe slot="form"  v-height="{offsetHeight:100}">
        <template slot-scope="{ row, index }" slot="displayOrder" >
          <Input type="text" v-model="editDisplayOrder" v-if="editIndex === index" />
          <span v-else>{{ row.displayOrder }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="sysEnmuDataKey">
          <Input type="text" v-model="editSysEnmuDataKey" v-if="editIndex === index" />
          <span v-else>{{ row.sysEnmuDataKey }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="sysEnmuDataValue">
          <Input type="text" v-model="editSysEnmuDataValue" v-if="editIndex === index" />
          <span v-else>{{ row.sysEnmuDataValue }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="enumIcon">
          <Input v-model="editEnumIcon" placeholder="选择图标" v-if="editIndex === index">
            <Button slot="append"  @click="nodeIcon">
              <Icon :type="editEnumIcon ? editEnumIcon : 'ios-search'">
              </Icon>
            </Button>
          </Input>
          <span v-if="editIndex !== index">
             <Icon :type="row.enumIcon" />
          </span>
        </template>
        <template slot-scope="{ row, index }" slot="isDefaultValue">
          <Enum :enumJsonKey="'base-isDefaultValue'"
                v-model="editIsDefaultValue"
                v-if="editIndex === index"></Enum>
          <span v-else>
            <EnumShow
                    :enum-group-code="'base'"
                    :enum-code="'isDefaultValue'"
                    :value="row.isDefaultValue"></EnumShow>
            </span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div v-if="editIndex === index">
            <div v-if="disabled" class="ml">
              <Button @click="handleSave(index)" type="success" ghost size="small">添加</Button>
              <Button @click="handleDelete(row, index)" type="error" ghost size="small">删除</Button>
            </div>
            <div v-else class="ml">
              <Button @click="handleSave(index)" type="success" ghost size="small">保存</Button>
              <Button @click="editIndex=-1" size="small" type="primary" ghost>取消</Button>
            </div>
          </div>
          <div v-else class="ml">
            <Button
                    @click="handleEdit(row, index)"
                    :disabled="disabled"
                    type="primary"
                    ghost
                    size="small"
            >编辑</Button>
            <Button
                    @click="handleDelete(row, index)"
                    :disabled="disabled"
                    type="error"
                    ghost
                    size="small"
            >删除</Button>
          </div>
        </template>
      </Table>
    </wrapper-edit>

  </div>

</template>

<script>
  import { save , edit, deleted}  from "@api/admin.js";
  import wrapperEdit from '@components/paas/wrapper-edit'
  import metaEdit from '@assets/js/meta-edit.js'
  import Enum from '@components/paas/enum-form'
  import EnumShow from '@components/paas/enum-show'
  import IconSelect from '@components/icon/icon'
  export default {
    name: "enum-edit",
    mixins:[metaEdit],
    components:{wrapperEdit,Enum,EnumShow,IconSelect},
    data(){
      return {
        serviceUrl: "/sys/enum",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        currentChildrenIdName:'id',
        paasFormData:{
          sysEnumCode: '',
          sysEnumGroupCode: '',
          datas: []
        },
        tableColumns:[
          {
            title: '序号',
            slot: 'displayOrder'
          },
          {
            title: '枚举显示值KEY',
            slot: 'sysEnmuDataKey',
          },
          {
            title: '枚举保存值VALUE',
            slot: 'sysEnmuDataValue',

          },
          {
            title: '显示图标',
            slot: 'enumIcon',

          },
          {
            title: '是否默认显示',
            slot: 'isDefaultValue',
          },
          {
            title: '添加',
            renderHeader: (h, colObj) => {
              return h('div', [
                h('Button', {
                  props: {
                    icon: 'md-add',
                    type:"warning"
                  },
                  on: {
                    click: () => {
                      console.log(this.paasFormData);
                      //首先判断主表是否保存
                      if(!this.paasFormData.id){
                        this.$Message.error('请先添加保存主表');
                      }else{
                        this.addRow();
                      }
                    }
                  },
                  class: 'paas-table-btn'
                }, " 添 加")
              ]);
            },
            slot: 'action'
          }
        ],
        paasFormRules: {
          sysFuncName: { required: true, message: '枚举名称不能为空', trigger: 'blur' },
          sysEnumCode: { required: true, message: '枚举编码不能为空', trigger: 'blur' },
        },
        disabled: false,
        editIndex: -1,  // 当前聚焦的输入框的行数
        editDisplayOrder: '',  // 第一列输入框，当然聚焦的输入框的输入内容，与 data 分离避免重构的闪烁
        editSysEnmuDataKey: '',  // 第二列输入框
        editSysEnmuDataValue: '',  // 第三列输入框
        editEnumIcon:"", //第四列输入框
        editIsDefaultValue: '',  // 第四列输入框
        redirectName:'name',  //返回和保存主表跳转
        nodeIconModal:false,
      }
    },

    methods:{
      /**
       * 新增一行
       * */
      addRow(){
        let obj = {
          id: '',
          sysEnumId: '',
          sysEnmuDataKey: '',
          sysEnmuDataValue: '',
          enumIcon:'',
          displayOrder: this.paasFormData.datas.length + 1,
          isDefaultValue: ''
        };

        this.paasFormData.datas.push(obj);
        //然后修改新增的这条数据
        this.handleEdit(obj,this.paasFormData.datas.length-1);
        this.disabled = true;
      },
      /**
       * 渲染枚举编码
       * */
      createdCallback(data) {
        if(this.$route.query.sysEnumGroupCode){
          this.paasFormData.sysEnumGroupCode = this.$route.query.sysEnumGroupCode;
        }
      },
      /**
       * 保存逻辑
       * @param name
       * @param url
       */
      paasFormSubmit(name,url){
        if(!url) {
          url = this.$store.state.sysApi+this.serviceUrl+"/save";
        }
        this.paasFormSubmitBefore();
        this.$refs[name].validate((valid) => {
          if (valid){
            let enumFormData = {};
            if(name === "paasForm"){
              for(let key  in this.paasFormData){
                if(key !== "datas"){
                  enumFormData[key] = this.paasFormData[key];
                }
              }
            }
            this.axios.post(url, enumFormData).then(res => {
              ;
              if(res.code === 200) {
                this.$Message.info('数据保存成功！');
                this.paasFormData[this.currentIdFiledName] = res.data.entity[this.currentIdFiledName];
                this.paasFormData.paasRepeatSubmitFlag = res.data.paasRepeatSubmitFlag;
                //console.log(res);
              }
            }).catch((error) => {
              ;
              this.$Message.error('数据保存失败，请重试！');
            });
          }
        })
      },
      handleTempSave(index){
        this.paasFormData.datas[index].displayOrder = this.editDisplayOrder;
        this.paasFormData.datas[index].sysEnmuDataKey = this.editSysEnmuDataKey;
        this.paasFormData.datas[index].sysEnmuDataValue = this.editSysEnmuDataValue;
        this.paasFormData.datas[index].isDefaultValue = this.editIsDefaultValue;
        this.paasFormData.datas[index].enumIcon = this.editEnumIcon;
        this.paasFormData.datas[index].sysEnumId = this.paasFormData.id;
        this.paasFormData.datas[index].paasRepeatSubmitFlag = this.paasRepeatSubmitFlag;
        this.editIndex = -1;
      },
      /**
       * 子表保存逻辑
       * */
      handleSave(index){
        this.handleTempSave(index);
        let id = this.paasFormData.datas[index].id;
        save("/sys/enum/data", this.paasFormData.datas[index]).then(
                res => {
                  if(res.code === 200) {
                    this.$Message.info('数据保存成功！');
                    this.paasFormData.datas[index][this.currentChildrenIdName] = res.data.entity[this.currentChildrenIdName];
                    if(!id){
                      this.addRow();
                    }
                  }
                }).catch(error=> {
          this.$Message.error('数据保存失败，请重试！');
        });
      },
      /**
       * 修改一行的数据
       * @param row
       * @param index
       */
      handleEdit(row,index){
        let param = "id="+row.id;
        edit("/sys/enum/data",param).then(res =>{
          this.editDisplayOrder = row.displayOrder;
          this.editSysEnmuDataKey = row.sysEnmuDataKey;
          this.editSysEnmuDataValue = row.sysEnmuDataValue;
          this.editIsDefaultValue = row.isDefaultValue;
          this.editEnumIcon = row.enumIcon;
          this.paasRepeatSubmitFlag = res.data.paasRepeatSubmitFlag;
          this.editIndex = index;
        });

      },
      handleDelete(row,index){
        let newDatas = [];
        let data;
        let initIndex = 1;
        for(let i = 0; i < this.paasFormData.datas.length; i++) {
          if(i !== index) {
            data = this.paasFormData.datas[i];
            data.displayOrder = initIndex;
            initIndex++;
            newDatas.push(data);
          }
        }

        if(row[this.currentChildrenIdName]){
          deleted("/sys/enum/data","id",row[this.currentChildrenIdName])
                  .then(res=> {
                    if(res.code === 200) {
                      this.paasFormData.datas = newDatas;
                      //this.paasFormData.datas.splice(index, 1);
                    }
                  }).catch(error=>{
            this.$Message.error('数据删除失败，请重试！');
          });
        }else{
          this.paasFormData.datas = newDatas;
          //this.paasFormData.datas.splice(index, 1);
        }
        this.disabled = false;
      },
      /**
       * 选择图标
       */
      nodeIcon(){
        this.nodeIconModal = true;
      },
      /**
       * 保存图标
       * @param item
       */
      saveIcon(item) {
        this.editEnumIcon = item;
        this.nodeIconModal = false;
      },
    },

  }
</script>

<style scoped>
  .enum-table >>> .ivu-table{
    overflow-y:scroll;
  }
  .add-row {
    margin: 16px;
  }
  .enum-table >>> .ivu-table-wrapper {
    overflow: inherit;
  }
  .enum-table >>> .ivu-table th {
    background: #fff;
  }
  .ml button {
    margin-right: 10px;
  }
</style>
